import defaultTo from "ramda/es/defaultTo";
import { resolveValue } from '../../../utils';
export const resolveRequestParamsWithState = (callAPI, withCredentials = true)=>async (state)=>{
        const resolveValueWithState = resolveValue(state);
        return {
            body: await resolveValueWithState(callAPI.body),
            url: await resolveValueWithState(callAPI.endpoint),
            headers: await resolveValueWithState(callAPI.headers),
            withCredentials: defaultTo(withCredentials, callAPI.withCredentials),
            method: callAPI.method,
            responseType: callAPI.responseType ?? ''
        };
    };
